import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const UOMs = lazy(() => componentLoader(() => import("./components/UOMs")));

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <UOMs />
      </section>
    </Suspense>
  </div>
);
